import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { equals, path, prop, or, propOr } from "ramda";

import { FREE_DRAWING, MARKER } from "~/constants/shape-types";
import { rgbaObjectToString, rgbaStringToObject } from "~/utils";

export const DEFAULT_STROKE_WIDTH = 2;

export const SET_DRAWING_MODE = "APP@FABRIC::SET_DRAWING_MODE";
export const SET_SHAPE_TYPE = "APP@FABRIC::SET_SHAPE_TYPE";
export const SET_PRIMARY_COLOR = "APP@FABRIC::SET_PRIMARY_COLOR";
export const SET_SELECTION_COLOR = "APP@FABRIC::SET_SELECTION_COLOR";
export const SET_IS_DRAGGING = "APP@FABRIC::SET_IS_DRAGGING";
export const SET_STROKE_WIDTH = "APP@FABRIC::SET_STROKE_WIDTH";
export const SET_SELECTION_STROKE_WIDTH = "APP@FABRIC::SET_SELECTION_STROKE_WIDTH";

export const setDrawingMode = createAction(SET_DRAWING_MODE);
export const setShapeType = createAction(SET_SHAPE_TYPE);
export const setPrimaryColorObject = createAction(SET_PRIMARY_COLOR);
export const setSelectionColorObject = createAction(SET_SELECTION_COLOR);
export const setSelectionColorString = createAction(SET_SELECTION_COLOR, rgbaStringToObject);
export const setSelectionStrokeWidth = createAction(SET_SELECTION_STROKE_WIDTH);
export const setIsDragging = createAction(SET_IS_DRAGGING);
export const setStrokeWidth = createAction(SET_STROKE_WIDTH);

export const toggleDrawingMode = () => (dispatch, getState) => {
  const isDrawingMode = selectIsDrawingMode(getState());
  dispatch(setDrawingMode(!isDrawingMode));
  if (isDrawingMode) dispatch(setShapeType(null));
};

const selectFabric = path(["application", "fabric"]);

export const selectIsDrawingMode = createSelector(selectFabric, prop("isDrawingMode"));

export const selectShapeType = createSelector(selectFabric, prop("shapeType"));

export const selectIsFreeDrawing = createSelector(selectShapeType, shapeType =>
  or(equals(shapeType, FREE_DRAWING), equals(shapeType, MARKER))
);

export const selectPrimaryColorObject = createSelector(selectFabric, prop("primaryColor"));

export const selectPrimaryColorString = createSelector(selectFabric, fabric =>
  rgbaObjectToString(propOr({}, "primaryColor", fabric))
);

export const selectSelectionColorObject = createSelector(selectFabric, prop("selectionColor"));

export const selectIsDragging = createSelector(selectFabric, prop("isDragging"));
export const selectSelectionStrokeWidth = createSelector(selectFabric, prop("selectionStrokeWidth"));
export const selectStrokeWidth = createSelector(selectFabric, prop("strokeWidth"));

const initialState = () => ({
  isDrawingMode: false,
  shapeType: null,
  primaryColor: { r: 0, g: 0, b: 0, a: 1 },
  selectionColor: null,
  isDragging: false,
  strokeWidth: DEFAULT_STROKE_WIDTH
});

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SET_DRAWING_MODE:
      return { ...state, isDrawingMode: action.payload };
    case SET_SHAPE_TYPE:
      return { ...state, shapeType: action.payload };
    case SET_PRIMARY_COLOR:
      return { ...state, primaryColor: action.payload };
    case SET_SELECTION_COLOR:
      return { ...state, selectionColor: action.payload };
    case SET_IS_DRAGGING:
      return { ...state, isDragging: action.payload };
    case SET_STROKE_WIDTH:
      return { ...state, strokeWidth: action.payload };
    case SET_SELECTION_STROKE_WIDTH:
      return { ...state, selectionStrokeWidth: action.payload };
    default:
      return state;
  }
}
